import React from 'react';

function Terms() {
  const lastUpdated = new Date().toISOString().split('T')[0];

  return (
    <div className="container">
      <section className="content-section">
        <h2>Terms & Conditions</h2>
        <p className="last-updated">Last updated: {lastUpdated}</p>

        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the Nouria mobile application ("App") and website,
            you accept and agree to be bound by the terms and provision of this agreement.
            This includes consent to electronic communications and records.
            If you do not agree to abide by these terms, please do not use this App or website.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Medical Disclaimer (Critical)</h2>
          <p>
            Nouria provides nutrition tracking based on AI estimations and is for educational purposes only.
            It is <strong>NOT</strong> medical advice. AI estimates may be inaccurate.
            Always consult a physician before starting any diet or fasting protocol.
            <strong> NEVER</strong> disregard professional medical advice because of information in this App.
            By using this App, you assume all risks associated with dietary changes.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. User Accounts</h2>
          <p>
            To use certain features of the App, you must register for an account using Google Sign-In.
            You are responsible for maintaining the confidentiality of your account information and for
            all activities that occur under your account.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. User Content</h2>
          <p>
            You retain ownership of any data, text, images, or other materials ("User Content") that you submit
            to the App. By submitting User Content, you grant Nouria a worldwide, non-exclusive,
            royalty-free license to use, reproduce, and display such content solely for the purpose of
            providing and improving the App services.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Prohibited Conduct</h2>
          <p>
            You agree not to use the App for any unlawful purpose or in any way that interrupts, damages,
            or impairs the service. You may not attempt to gain unauthorized access to any portion
            of the App or any other systems or networks connected to the App.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Intellectual Property</h2>
          <p>
            All content, features, and functionality of information found on the App (excluding User Content)
            are the exclusive property of Nouria and its licensors and are protected by copyright, trademark,
            and other intellectual property laws.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Modification of Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify you of any changes by
            posting the new Terms & Conditions on this page. Your continued use of the App after any
            such changes constitutes your acceptance of the new Terms & Conditions.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability,
            for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Governing Law and Jurisdiction</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of India.
            For users in the USA, UK, and European Union, specific local consumer protection and
            data privacy laws (such as CCPA or GDPR) may also apply where applicable.
            Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts of Maharashtra, India.
          </p>
        </section>

        <section className="terms-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:<br /><br />
            Email: <a href="mailto:support@nouria.fit">support@nouria.fit</a>
          </p>
        </section>
      </section>
    </div>
  );
}

export default Terms;
